module.exports = __webpack_public_path__ + "img/content-img1_3.3049a1c8.png";